/**
 * 用来计算视图曝光help类
 */
export default class ViewVisibleHelp {
  private map = new Map();

  /**
   * 模块可见
   * @param key
   */
  public visible(key: string) {
    this.map.set(key, Date.now());
  }

  /**
   * 模块不可见时调用，返回模块显示时长（需要和visible方法成对调用）
   * @param key
   * @return 显示时长
   */
  public invisible(key: string): number {
    let startTime = this.map.get(key);
    if (Number(startTime) === 0) {
      startTime = Date.now();
    }
    const duration = Date.now() - startTime;
    return duration < 0 ? 0 : duration;
  }
}
